import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgLayoutGrid = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: "1em",
	height: "1em",
	viewBox: "0 0 24 24",
	fill: "none",
	stroke: "currentColor",
	strokeWidth: 2,
	strokeLinecap: "round",
	strokeLinejoin: "round",
	className: "lucide lucide-layout-grid",
	...props,
	children: [
		/* @__PURE__ */ _jsx("rect", {
			width: 7,
			height: 7,
			x: 3,
			y: 3,
			rx: 1
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: 7,
			height: 7,
			x: 14,
			y: 3,
			rx: 1
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: 7,
			height: 7,
			x: 14,
			y: 14,
			rx: 1
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: 7,
			height: 7,
			x: 3,
			y: 14,
			rx: 1
		})
	]
});
export { SvgLayoutGrid as ReactComponent };
